<template>
  <div class="form-builder assignment assignment-view">
    <div class="assignment-desc">
      <div class="md-layout-item">
        <div class="md-layout align-center">
          <div class="assignment-image md-layout-item">
            <img alt src="./assets/assignment_icon.svg" />
          </div>
          <div class="assignment-label md-layout-item">
            <div class="label-text" v-text="title"></div>
            <div>{{ coach }}</div>
            <div>
              {{ dueDate ? "Due " + $moment(dueDate).format("MMMM DD") : "" }}
            </div>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item"></div>
        </div>
      </div>
    </div>
    <md-card class="assignment-card">
      <md-card-content v-if="description">
        <h2>Instructions</h2>
        <div class="text-left clear-both" v-html="description"></div>
      </md-card-content>
      <activity-card :item="activity"></activity-card>
    </md-card>
  </div>
</template>

<script>
import HelpersMixin from "./HelpersMixin";

export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate", "editMode"],
  mixins: [HelpersMixin],
  data() {
    return {
      showSuccessMessage: false,
      assigned: window.drupalSettings.assigned || {},
      uuid: window.drupalSettings.assigned.uuid || null,
      image: null,
      dueDate:
        window.drupalSettings.assigned.data.due_date || null,
      title:
        window.drupalSettings.assigned.data.title || null,
      description:
        window.drupalSettings.assigned.data.description || "",
      coach:
        window.drupalSettings.assigned.data.coach.name || "",
      activity:
        window.drupalSettings.assigned.data.activity || null,
    };
  },
};
</script>
<style lang="scss">
.clear-both {
  &::after {
    display: block;
    content: "";
    clear: both;
  }
}

.assignment-view {
  .assignment-section {
    padding-left: 0;
    padding-right: 0;
    .md-layout.align-left {
      float: none;
    }
  }
}
.assignment-desc {
  background-color: $blue-dark !important;
  background-position: center bottom;
  padding-top: 20px;
  padding-bottom: 10px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
  min-height: 180px;
  .assignment-image {
    width: 140px;
    max-width: 140px;
    margin-right: 32px;
    > img {
      transition: $transition;
      transition: var(--transition);
    }
    &:hover {
      > img {
        transform: scale(1.1);
      }
    }
  }
  .assignment-label {
    width: 100%;
    color: #ffffff;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    font-family: $font-source-sans-pro;
    .label-text {
      font-family: $font-filson-soft;
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 15px;
      //overflow: unset;
    }
  }
}
.md-app-content {
  .assignment-card {
    overflow: hidden;
    .md-card-content {
      padding-bottom: 0;
    }
    .activity-card-wrapper {
      margin: 24px;
    }
  }
}
</style>
